import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import { Link } from 'react-router-dom'

export default class DisplayLabel extends Component {
  // Helper to get display name for user
  getUserDisplayName(user) {
    if (!user) return ''
    if (!user.firstName && !user.lastName) {
      return user.userId
    } else if (!user.firstName) {
      return user.lastName
    } else if (!user.lastName) {
      return user.firstName
    } else {
      return `${user.firstName} ${user.lastName}`
    }
  }

  renderOwner(license) {
    if (license.group && license.user) {
      return (
        <div>
          <p>
            <FontAwesome name="user" size="lg" /> {this.getUserDisplayName(license.user)} - {license.user.userId} - {license.user.email}
          </p>
          <p>
            <FontAwesome name="users" size="lg" /> {license.group.name}
          </p>
        </div>
      )
    } else if (license.group) {
      return (
        <span>
          <FontAwesome name="users" size="lg" /> {license.group.name}
        </span>
      )
    } else if (license.user) {
      return (
        <span>
          <FontAwesome name="user" size="lg" /> {this.getUserDisplayName(license.user)}
        </span>
      )
    } else if (license.customer) {
      return (
        <span>
          <FontAwesome name="building-o" size="lg" /> {license.customer.name}
        </span>
      )
    }
    return <span>&nbsp;</span>
  }

  renderOwnerTitle(license) {
    const fullName = this.getUserDisplayName(license.user)

    if (license.group && license.user) {
      return (
        <span className="property-title owner">
          <FontAwesome name="user" size="2x" />
          <Link to={`/gebruikers/${license.user.id}`}>
            <span className="text">{fullName}</span>
          </Link>
          <span className="user-group">
            {' '}
            ( <FontAwesome name="users" size="2x" /> {license.group.name} )
          </span>
        </span>
      )
    } else if (license.group) {
      return (
        <span className="property-title owner">
          <FontAwesome name="users" size="2x" />
          <Link to={`/groepen/${license.group.id}`}>
            <span className="text">{license.group.name}</span>
          </Link>
        </span>
      )
    } else if (license.user) {
      return (
        <span className="property-title owner">
          <FontAwesome name="user" size="2x" />
          <Link to={`/gebruikers/${license.user.id}`}>
            <span className="text">{fullName}</span>
          </Link>
        </span>
      )
    } else if (license.customer) {
      return (
        <span className="property-title owner">
          <FontAwesome name="building-o" size="2x" />
          <Link to={`/klanten/${license.customer.id}`}>
            <span className="text">{license.customer.name}</span>
          </Link>
        </span>
      )
    }
    return <span className="property-title owner">&nbsp;</span>
  }

  renderStatus(license) {
    if (license.active) {
      return <FontAwesome name="check" size="2x" className="active" />
    } else {
      return <FontAwesome name="times" size="2x" className="inactive" />
    }
  }

  render() {
    const { type, value } = this.props

    switch (type) {
      case 'OWNER':
        return this.renderOwner(value)
      case 'OWNER_TITLE':
        return this.renderOwnerTitle(value)
      case 'STATUS':
        return this.renderStatus(value)
      default:
        return <span>{value}</span>
    }
  }
}